import { render, staticRenderFns } from "./RowText.vue?vue&type=template&id=3f66c41e&scoped=true"
import script from "./RowText.vue?vue&type=script&lang=js"
export * from "./RowText.vue?vue&type=script&lang=js"
import style0 from "./RowText.vue?vue&type=style&index=0&id=3f66c41e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f66c41e",
  null
  
)

export default component.exports